{
  "PROJECT_TRACKER": {
    "ASK_A_QUESTION": "Ask a question",
    "COMPLETED_ON": "Completed on {{date}}",
    "IN_PROGRESS": "In Progress",
    "ESTIMATED_COMPLETION": "Estimated completion {{date}}",
    "WAITING_ON_CUSTOMER": "Waiting on Customer",
    "YOU_APPROVED": "You approved {{title}}",
    "YOU_REQUESTED_REVISIONS": "You requested revisions for {{title}} with the message:",
    "FULFILLMENT_TEAM_MESSAGE": "Your fulfillment team sent a message:",
    "GENERIC_MESSAGE": "A message was sent:",
    "REVISIONS": "Revisions",
    "FILE_UPLOAD_PROMPT": "Attach a file...",
    "PROVIDE_FEEDBACK": "Provide Feedback",
    "APPROVE": "Approve task",
    "CANCEL": "Cancel",
    "SEND_FEEDBACK": "Send feedback",
    "UNDO": "Undo",
    "REOPEN_TASK": "Re-open task",
    "FILES": "Files",
    "FILE_DISCLAIMER": "Max file size 10MB. Max upload limit 10 files. Only images, videos, and documents are supported",
    "SUCCESS": {
      "FILE_UPLOAD": "File successfully uploaded",
      "FILE_UPLOAD_UNDO": "File upload successfully undone",
      "FILE_REMOVE": "File successfully removed",
      "FILE_REMOVE_UNDO": "File removal successfully undone",
      "APPROVE_TASK": "Task approved",
      "APPROVE_TASK_UNDO": "Task approval successfully undone",
      "FEEDBACK_PROVIDED": "Feedback provided"
    },
    "ERROR": {
      "ATTACHMENT": "Attachment type is not supported or exceeds the maximum file size. Only images, videos, and pdfs under 10MB are accepted",
      "FILE_UPLOAD": "There was a problem uploading the file",
      "FILE_UPLOAD_UNDO": "There was a problem undoing file upload",
      "FAIL_TO_ADD": "Failed to add attachment",
      "FILE_REMOVE": "There was a problem removing the file",
      "FILE_REMOVE_UNDO": "There was a problem undoing file removal",
      "APPROVE_TASK": "There was an error approving the task",
      "APPROVE_TASK_UNDO": "There was an error undoing task approval",
      "FEEDBACK_PROVIDED": "There was a problem publishing the feedback"
    },
    "PERCENTAGE_DONE": "{{percentage}}% done",
    "FULFILLMENT": "Fulfillment",
    "TASKS_COMPLETED": "{{numberTasks}} tasks completed",
    "UPLOADED_BY_YOU": "Uploaded by you",
    "UPLOADED_BY_FULFILLMENT_TEAM": "Uploaded by fulfillment team"
  },
  "ASK_QUESTION": {
    "TITLE": "Ask us a question about your ordered service",
    "TEXTAREA_TITLE": "Compose message",
    "SEND_MESSAGE": "Send message",
    "ASK_QUESTION_SUCCESS": "Successfully asked question",
    "ASK_QUESTION_ERROR": "There was an error asking your question"
  },
  "COMMENT": {
    "TITLE": "Comments",
    "NEW_COMMENT": {
      "LABEL": "Start typing to ask a question",
      "ACTION": "Submit",
      "SUBMIT_SUCCESS": "Successfully submitted question",
      "SUBMIT_ERROR": "There was an error submitting your question",
      "MAKE_PUBLIC": "Make comment public"
    },
    "FROM_STEP": "From step",
    "FULFILLMENT_AGENT": "Fulfillment Agent",
    "ERROR_LOADING_COMMENT": "Error loading details",
    "FROM": "from",
    "PUBLIC": "Public"
  },
  "FULFILLMENT_TRACKER": {
    "PROGRESS": "{{completed}}/{{total}} Tasks completed",
    "ASK_A_QUESTION": "Ask a question"
  },
  "SEND_MESSAGE_DIALOG": {
    "CHOOSE_RECIPIENT": "Choose recipient",
    "MESSAGE": "Message",
    "LABELS": {
      "VENDOR": "Vendor",
      "PARTNER": "Partner",
      "ACCOUNT": "Account",
      "CUSTOMER": "Customer",
      "INACTIVE": "Inactive",
      "ACCOUNT_DELETED": "Account Deleted"
    }
  },
  "COMMON": {
    "DUE": {
      "OVERDUE": "Overdue",
      "DUE_SOON": "Due Soon"
    },
    "STATUS": {
      "OPEN": "Open",
      "IN_PROGRESS": "In Progress",
      "WAITING_ON_CUSTOMER": "Waiting on Customer",
      "COMPLETED": "Completed"
    }
  },
  "PROJECT_LIST_CARD": {
    "TITLE": "Projects",
    "NO_PROJECTS": "There are no projects.",
    "VIEW_ALL": "View all",
    "DUE_DATE": "Due {{dueDate}}",
    "COMPLETED_DATE": "Completed {{completedDate}}",
    "INBOX_PREFILLED_MESSAGE": "Re: {{taskType}} - {{title}} ({{taskId}}) | {{companyName}} ({{accountGroupId}})"
  }
}
